import $ from 'jquery';

import ImageZoom from '../components/ImageZoom';
import StaticSlideshow from '../sections/StaticSlideshow';
import VariantHelper from '../utils/VariantHelper';
import ThemeUtils from '../utils/ThemeUtils';

export default class DynamicProduct {
  constructor(section) {
    this.$el = $(section.el);

    this.variantHelpers = null;

    this.$slideshow = $('[data-slideshow-container]');
    this.$productForm = $('[data-product-form]', this.$el);
    this.formID = this.$productForm.attr('data-product-form');

    // Form selectors
    this.productForm = `product-form-${this.formID}`;
    this.$productThumbnails = $('.product-thumbnails img', this.$el);
    this.$addToCartButton = $('.add-to-cart input', this.$el);
    this.$priceArea = $('.product-price', this.$el);
    this.$productMessage = $('[data-product-message]', this.$el);

    // Setup product information
    const $productJSON = $(`[data-product-json-${this.formID}]`, this.$el);
    const $productSettings = $(`[data-product-settings-${this.formID}]`, this.$el);

    if (!$productJSON.length) { return; }

    this.productJSON = JSON.parse($productJSON.text());
    this.productSettings = JSON.parse($productSettings.text());
    this.$variantDropdowns = $(`[data-option-select=${this.formID}]`, this.$el);
    this.$variantRadio = $(`[data-option-input=${this.formID}]`, this.$el);
    this.options = this.productJSON.options;
    this.variants = this.productJSON.variants;

    if (this.$slideshow.length) {
      this.slideshowSection = document.querySelector('.product-slideshow-section');
      this.slideshow = new StaticSlideshow({el: this.slideshowSection});
    } else {
      this.noImageURL = $('.product-big-image', this.$el).data('no-image-svg');
      if ($('html').hasClass('no-svg')) {
        this.noImageURL = $('.product-big-image', this.$el).data('no-image-png');
      }
    }

    this.processing = false;

    if (this.productSettings.imageZoom && !this.$slideshow.length) {
      this.ImageZoom = new ImageZoom({ el: $('.product-big-image', this.$el) });
    }

    this.setupVariants();
    this._bindEvents();

    Shopify.onError = XMLHttpRequest => this.handleErrors(XMLHttpRequest);
  }

  _bindEvents() {
    $('.product-thumbnails img', this.$el).on('click', (event) => this.updateProductImage(event));
    $('.product-form', this.$el).on('submit', (event) => this.addToCart(event));
  }

  setupVariants() {
    const variantHelperDefaults = {
      $addToCartButton: this.$addToCartButton,
      $priceFields: this.$priceArea,
      $productForm: this.$productForm,
      $productThumbnails: this.$productThumbnails,
      formID: this.formID,
      productSettings: this.productSettings,
      productJSON: this.productJSON,
    };

    if (this.$variantDropdowns.length) {
      let dropdownSettings = {
        $selector: this.$variantDropdowns,
        type: 'select',
      };

      dropdownSettings = ThemeUtils.extend(variantHelperDefaults, dropdownSettings);

      this.variantHelpers = new VariantHelper(dropdownSettings);
      this.$variantDropdowns.trigger('change');
    }

    if (this.$variantRadio.length) {
      let radioSettings = {
        $selector: this.$variantRadio,
        type: 'radio',
      };

      radioSettings = ThemeUtils.extend(variantHelperDefaults, radioSettings);

      this.variantHelpers = new VariantHelper(radioSettings);
      this.$variantRadio.trigger('change');
    }
  }

  updateProductImage(event) {
    this.$productThumbnails.removeClass('active');

    const $target = $(event.currentTarget);

    if (!$target.length) { return; }

    $target.addClass('active');

    $('.product-big-image img', this.$el)
      .attr({
        src: $target.data('high-res'),
        srcset: $target.data('high-res'),
        alt: $target.attr('alt'),
      });

    if (this.productSettings.imageZoom) {
      $('.product-big-image', this.$el).trigger('prepare-zoom');
    }
  }

  addToCart(e) {
    if (this.productSettings.cartRedirect) { return; }

    e.preventDefault();

    if (this.processing) { return; }
    this.processing = true;

    if (Modernizr.cssanimations) {
      $('.add-to-cart', this.$el).addClass('loading');
    } else {
      this.$addToCartButton.val(this.productSettings.processingText);
    }

    const quantity = $('input[name="quantity"]', this.$el).val();

    if ((quantity === '') || (quantity === '0')) {
      setTimeout(() => {
        $('input[name="quantity"]', this.$el)
          .addClass('error');
        this.$productMessage
          .removeClass('success')
          .addClass('error')
          .text(this.productSettings.setQuantityText);
        $('.add-to-cart', this.$el)
          .removeClass('loading');

        this.processing = false;
      },
      500);
    }

    Shopify.addItemFromForm(this.productForm, cartItem => setTimeout(() => {
      if (theme.isHome && $('.add-to-cart', this.$el).hasClass('express')) {
        window.location.href = '/checkout';
      } else {
        Shopify.getCart(cart => $('.cart-link .cart-count').text(cart.item_count));

        const successMessage = this.productSettings.successMessage.replace('** product **', cartItem.title);

          this.$productMessage
          .removeClass('error')
          .addClass('success')
          .html(successMessage);

        if (!Modernizr.cssanimations) {
          this.$addToCartButton.val(this.productSettings.addToCartText);
        }
      }

      this.processing = false;
    },
    1000));
  }

  handleErrors(errors) {
    const errorMessage = $.parseJSON(errors.responseText);
    const productTitle = this.productJSON.title;

    let errorDescription = errorMessage.description;
    if (errorMessage.description.indexOf(productTitle) > -1) {
      errorDescription = errorDescription
        .replace(productTitle, `<em>${productTitle}</em>`);
    }

    if (errorMessage.message === 'Cart Error') {
      setTimeout(() => {
        $('input[name="quantity"]', this.$el).removeClass('error');
        this.$productMessage
          .removeClass('success')
          .addClass('error')
          .html(errorDescription);
        $('.add-to-cart', this.$el)
          .removeClass('loading added-success')
          .addClass('added-error');

        if (!Modernizr.cssanimations) {
          this.$addToCartButton.val(this.productSettings.addToCartText);
        }

        this.processing = false;
      },
      1000);
    }
  }

  onSectionUnload(event) {
    if (!$(event.target).hasClass('section-product')) { return; }

    if (this.variantHelpers != null) {
      this.variantHelpers.prepareRemove();
    }

    if (this.ImageZoom != null) {
      this.ImageZoom.prepareRemove();
    }

    $('.product-thumbnails img', this.$el).off('click');
    $('.product-form', this.$el).on('submit');
  }
}
